module.exports = __webpack_public_path__ + "img/ski_sub_title1m.dbbb71d5.jpg";